import styles from "../../../assets/scss/common/button/floatingBtn.module.scss";
import {TopButton} from "./TopButton";
import {BuyVoucherBtn} from "./BuyVoucherBtn";
import {useLanguage, usePage, useScrollingEvent} from "../../../hooks/hooks";
import {useEffect, useMemo, useState} from "react";

export function FloatingBtn() {
    const {canLogin, isNotKorean} = useLanguage();
    const {isPurchasePage, isOrderPage, isWithAppPage} = usePage();
    const {scrollY} = useScrollingEvent();
    const [showBuyVoucher, setShowBuyVoucher] = useState(true);

    const showBuyVoucherButton = useMemo(
        () => !(isPurchasePage || isOrderPage || isNotKorean || isWithAppPage),
        [isPurchasePage, isOrderPage, isNotKorean, isWithAppPage]
    );

    useEffect(() => {
        const intervalId = setInterval(() => {
            setShowBuyVoucher(prev => !prev);
        }, 5000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className={styles.floatingBtn}>
            <TopButton scrollY={scrollY} hideBelowButton={!showBuyVoucherButton}/>
            {canLogin && showBuyVoucherButton && (
                showBuyVoucher
                    ? <BuyVoucherBtn key="test" variant="test"/>
                    : <BuyVoucherBtn key="counselor" variant="counselor"/>
            )}
        </div>
    );
}
